"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.powerplastics = exports.powerglass = exports.ledStripes = exports.ledSpots = exports.gutterPartitioning = exports.getPostPositions = exports.sides = exports.panelWidth = exports.offsetPanelWidth = exports.awningSize = exports.drainages = exports.fieldAmount = exports.roofFieldDepth = exports.roofFieldWidth = exports.sidePanelWidth = exports.consoleCount = exports.roofPitchDegree = exports.roofArea = exports.roofLength = exports.chevronCount = exports.postCount = exports.isGlassRoof = exports.mountingCostFactor = void 0;
function mountingCostFactor(roofingVariant) {
    if (!roofingVariant)
        return null;
    return ["vsg_klar", "vsg_milch"].includes(roofingVariant !== null && roofingVariant !== void 0 ? roofingVariant : "")
        ? { factor: 0.3, index: 0 }
        : ["poly_klar", "poly_opal"].includes(roofingVariant !== null && roofingVariant !== void 0 ? roofingVariant : "")
            ? { factor: 0.35, index: 1 }
            : { factor: 0.32, index: 2 };
}
exports.mountingCostFactor = mountingCostFactor;
function isGlassRoof(roofingVariant) {
    return ["vsg_klar", "vsg_milch", "powerglass"].includes(roofingVariant);
}
exports.isGlassRoof = isGlassRoof;
function postCount(roofWidth, roofingVariant) {
    const distance = isGlassRoof(roofingVariant) ? 4000 : 5000;
    return 1 + Math.ceil(roofWidth / distance);
}
exports.postCount = postCount;
function chevronCount(roofWidth, roofingVariant) {
    const distance = isGlassRoof(roofingVariant) ? 750 : 1000;
    return 1 + Math.ceil(roofWidth / distance);
}
exports.chevronCount = chevronCount;
function roofLength(depth, heightGutter, heightWall) {
    return Math.hypot(depth, heightWall - heightGutter);
}
exports.roofLength = roofLength;
function roofArea(width, depth, heightGutter, heightWall) {
    return width * roofLength(depth, heightGutter, heightWall);
}
exports.roofArea = roofArea;
function roofPitchDegree(depth, heightGutter, heightWall) {
    return Math.atan((heightWall - heightGutter) / depth) * 180 / Math.PI;
}
exports.roofPitchDegree = roofPitchDegree;
function consoleCount(roofWidth) {
    return Math.ceil(roofWidth / 800);
}
exports.consoleCount = consoleCount;
function sidePanelWidth(roofWidth, postCount) {
    return Math.floor(roofWidth / (postCount - 1));
}
exports.sidePanelWidth = sidePanelWidth;
function roofFieldWidth(roofWidth, chevronCount) {
    const glassWidth = roofWidth - (chevronCount * 55);
    return Math.floor((glassWidth - 10) / (chevronCount - 1));
}
exports.roofFieldWidth = roofFieldWidth;
function roofFieldDepth(depth) {
    const glassDepth = depth - 171.73 - 42.62 + 116;
    return Math.floor(glassDepth - 25 - 38.62);
}
exports.roofFieldDepth = roofFieldDepth;
function fieldAmount(width, fieldWidth) {
    return Math.ceil(width / fieldWidth);
}
exports.fieldAmount = fieldAmount;
function drainages(width, depth, heightGutter, heightWall) {
    return roofArea(width, depth, heightGutter, heightWall) >= 20000000 ? 2 : 1;
}
exports.drainages = drainages;
function awningSize(activeTab, start, end, fieldWidth, width, totalPosts, postOffsets, variant, depth, heightGutter = 0) {
    if (activeTab == 0)
        return {
            "width": (variant == "under_glass" ? (end - start) * fieldWidth - 113 : (end - start) * fieldWidth - 10).toFixed(1),
            "depth": (variant == "under_glass" ? depth - 170 : depth - 0).toString()
        };
    else if (activeTab == 1)
        return {
            "width": offsetPanelWidth(start, postOffsets, width, totalPosts).toFixed(1),
            "depth": heightGutter.toString()
        };
    else if (activeTab == 2)
        return {
            "width": depth.toString(),
            "depth": heightGutter.toString()
        };
    else
        return {
            "width": "0",
            "depth": "0"
        };
}
exports.awningSize = awningSize;
function offsetPanelWidth(panel, offsets, width, posts) {
    return panelWidth(width, posts) - offsets[panel] + offsets[panel + 1];
}
exports.offsetPanelWidth = offsetPanelWidth;
function panelWidth(width, posts) {
    return Math.floor(width / sides(posts));
}
exports.panelWidth = panelWidth;
function sides(posts) {
    return posts - 1;
}
exports.sides = sides;
function getPostPositions(width, postCount, offsets) {
    const correctedWidth = width - 110; // Weil die äußeren Pfosten ja etwas eingerückt sind
    const spaceBetweenPosts = correctedWidth / (postCount - 1);
    let resultList = [];
    if (offsets.length != postCount)
        throw new Error('There is a problem with the additional posts');
    for (let i = 0; i < postCount; i++) {
        resultList[i] = spaceBetweenPosts * i + 55 + offsets[i]; // Damit die äußeren Pfosten bündig abschließen
    }
    return resultList;
}
exports.getPostPositions = getPostPositions;
function gutterPartitioning(width, postCount, roofType, offsets) {
    const MAX_WIDTH_GLASS = 4000;
    const MAX_WIDTH_POLY = 5000;
    const currentLimitation = isGlassRoof(roofType) ? MAX_WIDTH_GLASS : MAX_WIDTH_POLY;
    if (width < currentLimitation)
        return [0];
    const postPositions = getPostPositions(width, postCount, offsets);
    let maxPossiblePost = 0;
    let remainingWidth = width;
    function getPostIndexRecursive(startIndex = 0) {
        if (remainingWidth <= currentLimitation)
            return [];
        const startValue = startIndex == 0 ? 0 : postPositions[startIndex];
        for (let i = startIndex; i < postCount; i++) {
            let correctedEndWidth = i == postCount - 1 ? width : postPositions[i]; // Damit nicht auf dem letzten Pfosten geteilt wird
            if (correctedEndWidth - startValue > currentLimitation)
                break;
            maxPossiblePost = i;
        }
        remainingWidth = width - postPositions[maxPossiblePost];
        return [maxPossiblePost, ...getPostIndexRecursive(maxPossiblePost)];
    }
    const postIndexList = getPostIndexRecursive();
    // Aus den Pfostenindexes die tatsächliche Länge der Pfosten bestimmen
    let gutterLengthList = [];
    postIndexList.forEach((it, index) => {
        let res = 0;
        const startValue = index == 0 ? 0 : postPositions[postIndexList[index - 1]];
        res += postPositions[it] - startValue;
        gutterLengthList.push(res);
        if (index == postIndexList.length - 1)
            gutterLengthList.push(width - postPositions[it]);
    });
    return gutterLengthList;
}
exports.gutterPartitioning = gutterPartitioning;
// lighting
function ledSpots(depth, chev) {
    const d = depth >= 3000 ? 2 : 1;
    return (chev - 2) * d;
}
exports.ledSpots = ledSpots;
function ledStripes(chev) {
    return chev - 2;
}
exports.ledStripes = ledStripes;
function powerglass(fieldWidth, fieldDepth, fieldAmount) {
    return ((fieldWidth * fieldAmount) * fieldDepth / 1000000); //Quadratmeter
}
exports.powerglass = powerglass;
function powerplastics(fieldAmount) {
    return fieldAmount;
}
exports.powerplastics = powerplastics;
//# sourceMappingURL=index.js.map